<template>
  <div class="flex shrink-0 flex-col items-end gap-3 light-theme">
    <div
      data-testid="shop-quantity-selector"
      class="flex h-10 w-[122px] min-w-[100px] items-center justify-center rounded-sm border border-primary bg-primary-subtlest px-3"
      tabindex="0"
      @keydown="onKeydown"
    >
      <button
        type="button"
        data-testid="shop-quantity-decrease-btn"
        :disabled="disabled || (isMin && !removeWhenZero)"
        :class="disabled || (isMin && !removeWhenZero) ? 'cursor-not-allowed text-primary-subtle' : 'text-primary'"
        class="flex h-6 w-6 items-center justify-center"
        :aria-label="count === 1 ? $t('FestivalShop.cart.removeItem') : $t('FestivalShop.cart.decreaseQuantity')"
        @click="decreaseQuantity"
      >
        <MdiSvg :path="count === 1 && removeWhenZero ? mdiTrashCanOutline : mdiMinus" :size="24" />
      </button>

      <div class="flex min-w-0 flex-1 items-center justify-center">
        <span data-testid="shop-quantity-count" class="txt-body-m-bold text-primary">{{ count }}</span>
      </div>

      <TooltipWrapper :key="isMax ? 'with-content' : 'without-content'" :z-index="maxReachedTooltipZIndex">
        <template #trigger>
          <div>
            <button
              type="button"
              data-testid="shop-quantity-increase-btn"
              :disabled="disabled || isMax"
              :class="disabled || isMax ? `cursor-not-allowed ${removeWhenZero ? 'text-disabled' : 'text-primary-subtle'}` : 'text-primary'"
              class="flex h-6 w-6 items-center justify-center"
              :aria-label="$t('FestivalShop.cart.increaseQuantity')"
              @click="increaseQuantity"
            >
              <MdiSvg :path="mdiPlus" :size="24" :class="isMax && removeWhenZero ? 'text-primary-subtle' : undefined" />
            </button>
          </div>
        </template>
        <template v-if="isMax" #content>{{ $t('FestivalShop.products.details.disabled_due_to_maximum') }}</template>
      </TooltipWrapper>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { mdiPlus, mdiMinus, mdiTrashCanOutline } from '@mdi/js'
import { MdiSvg, TooltipWrapper } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'

const props = defineProps<{
  count: number
  removeWhenZero?: boolean
  max?: number
  maxReachedTooltipZIndex?: number
  disabled?: boolean
}>()

const emit = defineEmits<{
  'update:quantity': [count: number]
}>()

const isMin = computed(() => props.count <= 1)
const isMax = computed(() => props.max != null && props.count >= props.max)

function increaseQuantity() {
  if (isMax.value) return
  emit('update:quantity', props.count + 1)
}

function decreaseQuantity() {
  emit('update:quantity', props.count - 1)
}

function onKeydown(event: KeyboardEvent) {
  if (props.disabled) return
  if (event.key === 'ArrowUp') {
    if (isMax.value) return
    event.preventDefault()
    increaseQuantity()
  } else if (event.key === 'ArrowDown') {
    if (isMin.value && !props.removeWhenZero) return
    event.preventDefault()
    decreaseQuantity()
  }
}
</script>
